// assets/slider-cat1.js
(function () {
  function initSection(section) {
    const track = section.querySelector('.slider-cat1-track');
    const prev  = section.querySelector('.slider-cat1-prev');
    const next  = section.querySelector('.slider-cat1-next');
    if (!track || !prev || !next) return;

    function step() {
      const card = track.querySelector('.slider-cat1-card');
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.gap || styles.columnGap || 0) || 0;

      if (card) {
        return card.getBoundingClientRect().width + gap;
      }
      return Math.round(track.clientWidth * 0.8) || 300;
    }

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  }

  function initAll(root = document) {
    root.querySelectorAll('.slider-cat1-section').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
